/* RESPONSIBLE TEAM: team-workflows */
import GlobalLoadingRoute from 'embercom/routes/base/global-loading-route';

export default GlobalLoadingRoute.extend();
